export default __webpack_public_path__ + "static/media/011-pin.a897a777.png";